import {inject, injectable} from 'inversify';

import type {
  Expand,
  Expanded,
  MaybeExpanded,
} from '../../../../../../../api/types';
import type {BNFormApiModel} from '../../../../../../../api/types/bnrks/models';

import {
  userExpandCommon,
  type UserExpandedCommon,
} from '../../../../../../../api/user';
import {BaseExpandJrpc} from '../../../../../../../core/domain/Base/mappers/Base.expand.jrpc';
import {EnvProviderService} from '../../../../../../../core/system/env/EnvProvider.service';

@injectable()
export class CromExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      bound_form: [
        'form_id',
        ['user_id', {name: 'User not found'}, userExpandCommon],
      ],
    };
    const b2b = base,
      core = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace CromExpandJrpc {
  export type ExpandedFields = {
    form: MaybeExpanded<BNFormApiModel>;
    user: Expanded<UserExpandedCommon, 'name'>;
  };
}
